export const getApiErrorDetails = (error) => {
  const data = error?.response?.data || error?.data || error;
  const value = data?.error;

  if (value && typeof value === "object" && !Array.isArray(value)) {
    return {
      code: value.code || data?.errorCode,
      message: value.message || data?.errorMessage,
    };
  }

  return {
    code: data?.errorCode,
    message: data?.errorMessage,
  };
};

const getMessageFromErrorValue = (error) => {
  if (!error) return undefined;

  if (typeof error === "string") return error;

  if (Array.isArray(error)) {
    return error.find(item => typeof item === "string");
  }

  if (typeof error === "object") {
    return error.message || error.code;
  }

  return undefined;
};

export const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data || error?.data || error;
  const details = getApiErrorDetails(error);

  return (
    details.message ||
    getMessageFromErrorValue(data?.error) ||
    data?.errors?.find?.(item => item?.message)?.message ||
    error?.message ||
    fallback
  );
};

export const normalizeApiError = (error) => {
  const data = error?.response?.data;
  const details = getApiErrorDetails(error);

  if (!data || !details.message) return error;

  data.errorMessage = details.message;
  if (details.code) data.errorCode = details.code;

  if (
    data.success === false &&
    data.error &&
    typeof data.error === "object" &&
    !Array.isArray(data.error)
  ) {
    data.error = details.message;
  }

  error.message = details.message;
  error.apiError = details;

  return error;
};
